export const httpOrHttps = (baseRoute: string) => {
  if (baseRoute.startsWith('https://') || baseRoute.startsWith('http://')) {
    return baseRoute;
  } else {
    return `https://${baseRoute}`;
  }
};
